import { IEsgGameDataVM } from "@/shared/model/esg/esg-game-data-VM.model";
import { IDataWrapper } from "@/shared/model/global/data-wrapper.model";
import { ISurvey } from "@/shared/model/global/survey.model";
import axios from "axios";

const baseApiUrl = "api/esg-game";

export default class ESGGameService {
  public findEncryptedEsg(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/find-encrypted-esg`, id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public updateGameData(entity: IDataWrapper): Promise<IEsgGameDataVM> {
    return new Promise<IEsgGameDataVM>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update-game-data`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public computeGameData(entity: IDataWrapper): Promise<IEsgGameDataVM> {
    return new Promise<IEsgGameDataVM>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/compute-game-data`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public createPublicData(initGameData): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/create-public-data`, initGameData)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public saveClient(entity: IDataWrapper): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/save-client`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public contactAdvisor(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/contact-advisor`, id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getResults(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/get-results`, id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public sendResults(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/send-results`, id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  updateSurvey(survey: ISurvey) {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update-survey`, survey)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public sendNotInterestedMail(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/send-not-interested-mail/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
